import BinderDocumentService from '@/Modules/Binder/ChildBinder/BinderDocument/BinderDocumentService.js'
import ClientDocumentService from '@/Modules/Client/ClientDocument/ClientDocumentService.js'
import EntityDocumentService from '@/Modules/Entity/EntityDocument/EntityDocumentService.js'
import InvoiceDocumentService from '@/Modules/Invoice/InvoiceDocument/InvoiceDocumentService.js'
import QuoteDocumentService from '@/Modules/Quote/QuoteDocument/QuoteDocumentService.js'
import StatementDocumentService from '@/Modules/Statement/StatementDocument/StatementDocumentService.js'
import SchemaDocumentService from '@/Modules/Schema/SchemaDocument/SchemaDocumentService.js'

export const documentServices = {
  quote: QuoteDocumentService,
  entity: EntityDocumentService,
  invoice: InvoiceDocumentService,
  binder: BinderDocumentService,
  client: ClientDocumentService,
  statement: StatementDocumentService,
  schema: SchemaDocumentService,
}

export default {
  methods: {
    handleFileUpload(formData, id, multiple, service = documentServices.quote) {
      if (multiple) {
        return service.createMultiple(id, formData)
      }

      return service.create(id, formData)
    },
  },
}
